"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewDcSession extends new_item_1.default {
    constructor(newDcSession) {
        super();
        this.startTime = newDcSession.startTime;
        this.endTime = newDcSession.endTime;
        this.priceCap = newDcSession.priceCap;
        this.chargePointId = newDcSession.chargePointId;
        this.status = newDcSession.status;
        this.invoiceDetails = newDcSession.invoiceDetails;
        this.reasonForEnd = newDcSession.reasonForEnd;
        this.totalCost = newDcSession.totalCost;
        this.totalUsage = newDcSession.totalUsage;
        this.priceCapFormatted = newDcSession.priceCapFormatted;
        this.totalCostFormatted = newDcSession.totalCostFormatted;
        this.totalUsageFormatted = newDcSession.totalUsageFormatted;
    }
}
exports.default = NewDcSession;
//# sourceMappingURL=new-dcSession.js.map